import { IconButton } from '@material-ui/core';
import { GetApp, Print } from '@material-ui/icons';
import { useBarcode } from 'next-barcode';
import useSyles from './styles';
import usePrintBarcode from './usePrintBarcode';
import { useRef } from 'react';

const Barcode = ({ barcode = 'sin código', nid = '' }: any) => {
  const printArea = useRef(null);
  const classes = useSyles();
  const { inputRef } = useBarcode({
    value: barcode,
    options: {
      background: '#ffffff',
      fontSize: 22,
    },
  });
  const { onPrint, downloadFull } = usePrintBarcode({ wrapperRef: printArea });

  return (
    <div className={classes.flex}>
      <div className={classes.barcode} id='mybarcode-html' ref={printArea}>
        <span className={classes.title_nid}>{nid}</span>
        <canvas id='mybarcode' ref={inputRef} />
      </div>
      <div className={classes.actions}>
        <IconButton
          size='medium'
          aria-label='imprimir'
          onClick={() => onPrint()}
          className={classes.button}
        >
          <Print color='secondary' />
        </IconButton>
        <IconButton
          size='medium'
          aria-label='imprimir'
          color='secondary'
          onClick={downloadFull}
          className={classes.button}
        >
          <GetApp color='secondary' />
        </IconButton>
      </div>
    </div>
  );
};

export default Barcode;
